export const GLOBAL_CTAS_LPS_FLAG_NAME = 'pen-5084_v1'
